import React from "react";
import { Link } from "react-router-dom";
import ScheduleDemoButton from "../../components/content/demoButton/customButton";
import { RouteNavigation } from "../../Routes";

function AboutUs() {
  return (
    <div>
      <div className="sm:flex items-center max-w-screen-xl m-auto">
        <div className="sm:w-1/2 p-10">
          <div className="image object-center text-center">
            <img alt="dummy" src="https://i.imgur.com/WbQnbas.png" />
          </div>
        </div>
        <div className="sm:w-1/2 p-5">
          <div className="text">
            <span className="text-gray-500 poppins_medium border-b-2 border-[#f6892f] uppercase">
              About us
            </span>
            <h2 className="my-4 poppins_bold text-3xl  sm:text-4xl ">
              About <span className="text-[#f6892f]">Mobi Pos</span>
            </h2>
            <p className="text-gray-700 poppins_medium">
              Welcome to Mobi POS, where we simplify business management with
              our smart point-of-sale systems. From sales and inventory to
              customer care, our solutions make it easy to run your business
              smoothly and efficiently.
            </p>
          </div>
        </div>
      </div>
      <div className="py-6 sm:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="mb-4 text-orange-800 px-4 py-2 rounded-lg md:w-64 md:mx-auto text-xs poppins_semibold tracking-widest uppercase title-font">
              Why choose us?
            </h2>
            <p className=" mt-2 text-3xl leading-8 poppins_semibold tracking-tight text-gray-900 sm:text-4xl">
              We know tech, we know billing. We are{" "}
              <span className="text-[#f6892f]">Mobi Pos</span> experts.
            </p>
            <p className="mt-4 max-w-2xl text-lg text-gray-500 lg:mx-auto poppins_medium">
              We master next-gen billing for diverse businesses. We prioritize
              customer needs and ensure smooth management of sales and inventory
              with our advanced solutions.
            </p>
          </div>

          <div className="mt-10">
            <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
              {/* 1 */}
              <div className="flex items-center gap-5">
                <div className="w-10 h-10 overflow-hidden">
                  <img
                    src="/images/elements/order_management.png"
                    alt="order_management"
                    className="w-full object-contain"
                  />
                </div>
                <div>
                  <p className=" text-lg leading-6 poppins_bold text-gray-700">
                    Efficient Order Management
                  </p>
                  <p className="mt-2 text-base text-gray-500 poppins_medium">
                    Handle customer orders swiftly, ensuring quick service and
                    satisfaction.
                  </p>
                </div>
              </div>
              {/* 2 */}
              <div className="flex items-center gap-5">
                <div className="w-10 h-10 overflow-hidden">
                  <img
                    src="/images/elements/tally.png"
                    alt="tally"
                    className="w-full object-contain"
                  />
                </div>
                <div>
                  <p className=" text-lg leading-6 poppins_bold text-gray-700">
                    Seamless Tally Integration
                  </p>
                  <p className="mt-2 text-base text-gray-500 poppins_medium">
                    Integrate effortlessly with Tally for simplified accounting
                    and reporting.
                  </p>
                </div>
              </div>
              {/* 3 */}
              <div className="flex items-center gap-5">
                <div className="w-10 h-10 overflow-hidden">
                  <img
                    src="/images/elements/customize_bussiness.png"
                    alt="customize_bussiness"
                    className="w-full object-contain"
                  />
                </div>
                <div>
                  <p className=" text-lg leading-6 poppins_bold text-gray-700">
                    Customizable for Your Business
                  </p>
                  <p className="mt-2 text-base text-gray-500 poppins_medium">
                    Adapt Mobi POS features to match unique needs of your
                    business model.
                  </p>
                </div>
              </div>
              {/* 4 */}
              <div className="flex items-center gap-5">
                <div className="w-10 h-10 overflow-hidden">
                  <img
                    src="/images/elements/van_sale.png"
                    alt="van_sale"
                    className="w-full object-contain"
                  />
                </div>
                <div>
                  <p className=" text-lg leading-6 poppins_bold text-gray-700">
                    On-the-Go Sales Tracking
                  </p>
                  <p className="mt-2 text-base text-gray-500 poppins_medium">
                    Monitor sales performance anytime, anywhere with mobile
                    access capabilities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="py-8 sm:py-24 relative">
        <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
          <div className="w-full justify-start items-center gap-12 grid lg:grid-cols-2 grid-cols-1">
            <div className="w-full justify-center items-start gap-6 grid grid-cols-2 lg:order-first order-last">
              <div className="lg:justify-center sm:justify-end justify-start items-start gap-2.5 flex">
                <img
                  className="rounded-xl object-cover w-full"
                  src="/images/about_us/02.png"
                  alt="about Us image"
                />
              </div>
              <img
                className="rounded-xl object-cover w-full"
                src="/images/about_us/03.png"
                alt="about Us image"
              />
            </div>
            <div className="w-full flex-col justify-center lg:items-start items-center gap-10 inline-flex">
              <div className="w-full flex-col justify-center items-start gap-8 flex">
                <div className="w-full flex-col justify-start lg:items-start items-center gap-3 flex">
                  <h2 className="text-gray-900 text-2xl min-[480px]:text-4xl poppins_bold leading-normal lg:text-start text-center">
                    Mobi POS Your All-in-One Billing Solution
                  </h2>
                  <p class="text-gray-500 text-base poppins_medium leading-relaxed lg:text-start text-center">
                    Mobi POS is a fast, dependable billing system that makes
                    managing sales, inventory, and payments effortless. It’s
                    designed to be simple, helping businesses reduce mistakes,
                    save time, and keep things running smoothly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 relative">
        <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
          <div className="w-full justify-start items-center gap-8 grid lg:grid-cols-2 grid-cols-1">
            <div className="w-full flex-col justify-start lg:items-start items-center gap-10 inline-flex">
              <div className="w-full flex-col justify-start lg:items-start items-center gap-4 flex">
                <h2 className="text-gray-900 text-2xl min-[480px]:text-4xl poppins_bold leading-normal lg:text-start text-center">
                  Making Your Business Work Smarter with Mobi POS and Simple
                  Billing Solutions
                </h2>
                <p className="text-gray-500 text-base poppins_medium leading-relaxed lg:text-start text-center">
                  Mobi POS brings together advanced features like POS
                  integration, inventory tracking, UPI/card payment options,
                  staff reports, and cloud management. It simplifies operations,
                  boosts efficiency, and ensures smooth business management for
                  better productivity and reduced errors..
                </p>
              </div>
              <Link to={RouteNavigation.ScheduleDemo}>
                <ScheduleDemoButton
                  borderColor="black"
                  textColor="black"
                  bgColor="white"
                  hoverColor="black"
                >
                  Book Free Demo
                </ScheduleDemoButton>
              </Link>
            </div>
            <img
              className="hidden sm:block lg:mx-0 mx-auto h-full rounded-3xl object-cover"
              src="https://pagedone.io/asset/uploads/1717751272.png"
              alt="about Us image"
            />
          </div>
        </div>
      </section>

      <div className="relative isolate overflow-hidden bg-gray-900 py-24 sm:py-32">
        <img
          src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&crop=focalpoint&fp-y=.8&w=2830&h=1500&q=80&blend=111827&sat=-100&exp=15&blend-mode=multiply"
          alt=""
          className="absolute inset-0 -z-10 size-full object-cover object-right md:object-center"
        />
        <div
          className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
          aria-hidden="true"
        >
          <div
            className="aspect-1097/845 w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div
          className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
          aria-hidden="true"
        >
          <div
            className="aspect-1097/845 w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
          <div className="mx-auto lg:mx-0">
            <h2 className="text-3xl min-[480px]:text-5xl poppins_semibold tracking-tight text-white sm:text-7xl">
              Work with us
            </h2>
            <p className="mt-8 text-lg poppins_medium text-pretty text-gray-300 sm:text-xl/8">
              Work with us to bring your vision to life. Together, we'll create
              innovative solutions that drive success.
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-1 w-full flex-col items-center justify-center text-center px-4 py-10 sm:py-20 bg-gradient-to-r from-green-50/50 via-teal-50 to-green-50/50">
        <h1 className="mx-auto max-w-4xl text-2xl poppins_bold tracking-normal text-white-300 sm:text-7xl">
          Having doubts?{" "}
          <span className="relative whitespace-nowrap text-white-600">
            Get in touch{" "}
          </span>
          <span className="relative whitespace-nowrap text-orange-500">
            <svg
              aria-hidden="true"
              viewBox="0 0 418 42"
              className="absolute top-2/3 left-0 h-[0.58em] w-full fill-orange-500 dark:fill-orange-300/60"
              preserveAspectRatio="none"
            >
              <path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.780 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.540-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.810 23.239-7.825 27.934-10.149 28.304-14.005 .417-4.348-3.529-6-16.878-7.066Z"></path>
            </svg>
            <span className="relative">with US</span>
          </span>
        </h1>
        <h2 className="mx-auto mt-4 sm:mt-12 max-w-xl text-lg sm:text-white-400 text-white-500 leading-7 poppins_medium">
          We are your one-stop solution for all billing-related issues,
          available around the clock. Call us anytime, and our team will be
          ready to provide immediate assistance and support for your needs.
        </h2>
        <Link
          className="bg-orange-600 rounded-xl text-white poppins_medium px-4 py-3 sm:mt-10 mt-8 hover:bg-orange-500 transition"
          to={RouteNavigation.contact}
        >
          Connect with us!
        </Link>
      </div>
    </div>
  );
}

export default AboutUs;
